import { $Q, $Qll } from './querySelector';

class Pagination {
  constructor(document, paginateBy, id) {
    this.document = document;
    this.id = id;
    this.list = Object.values(
      $Qll('.wrapper-collections .results-wrapper li', document)
    );
    this.paginateBy = paginateBy;
    this.length = this.list.length;
    this.pages = {
      current: 1,
      next: null,
      prev: null,
    };

    this._init();
  }

  /**
   * Initialize pagination
   */
  async _init() {
    this.pages.total = Math.ceil(this.length / this.paginateBy);

    if (this.pages.total > 1) {
      for (let i = 1; i <= this.pages.total; i++) {
        this.pages.next = 2;
      }
    }

    this.assignItemsToPages();
    this.setHeaderInfo();
  }

  /**
   * This function divides the elements into different pages
   */
  assignItemsToPages() {
    this.pagination = {};

    for (let i = 0; i < this.pages.total; i++) {
      const by = this.paginateBy;
      const elementsInPage = this.list.slice(i * by, i * by + by);
      this.pagination[i] = elementsInPage;
    }
  }

  /**
   * It sets the header information
   */
  setHeaderInfo() {
    this.headerInfo = {};
    const current = this.pages.current;
    this.headerInfo.from = (current - 1) * parseInt(this.paginateBy) + 1;
    this.headerInfo.to =
      this.headerInfo.from + this.pagination[current - 1].length - 1;
  }

  /**
   * It updates the header information into DOM
   */
  updateHeaderInfo() {
    const resultsContainer = $Q('.results-container', this.document);
    const title = $Q('#results-container_collections');
    const textDOM = $Q('#collections-list .results-container__info');
    const input = $Q('.search-results__input');
    const textResults = document.querySelectorAll('.results-container__info--text span');

    const resultsText = resultsContainer.dataset.results;
    const forText = resultsContainer.dataset.for;

    const textToShow = `${this.headerInfo.from} ${textResults[0]?.innerHTML} ${this.headerInfo.to} ${textResults[1]?.innerHTML} ${this.length} ${textResults[2]?.innerHTML} ${title.innerText} ${textResults[3]?.innerHTML} <strong>"${input.value}"</strong>`;

    textDOM.innerHTML = textToShow;
  }

  /**
   * It updates pagination properties
   */
  updatePagination() {
    const pageNumbers = $Qll('#collections-list .pagination--nav .page-number');
    const nextArrow = $Q('#collections-list .next-arrow');
    const prevArrow = $Q('#collections-list .prev-arrow');

    pageNumbers.forEach((number, index) => {
      if (index + 1 === this.pages.current) {
        number.classList.add('current');
        this.checkArrow(nextArrow, prevArrow, index);
      } else {
        number.classList.remove('current');
        this.checkArrow(prevArrow, nextArrow, index);
      }
    });
  }

  /**
   * It checks the arrow to be shown or hidden
   * @param {HTMLElement} nextArrow : it is the next arrow element
   * @param {HTMLElement} prevArrow : it is the prev arrow element
   * @param {Number} index : it is the index for total pages
   */
  checkArrow(nextArrow, prevArrow, index) {
    if (index === 0) {
      nextArrow.classList.remove('hidden');
      prevArrow.classList.add('hidden');
    } else if (index + 1 === this.pages.total) {
      nextArrow.classList.add('hidden');
      prevArrow.classList.remove('hidden');
    } else {
      nextArrow.classList.remove('hidden');
      prevArrow.classList.remove('hidden');
    }
  }

  /**
   * It creates the DOM for pagination
   */
  createPaginationDOM() {
    if (this.pages.total <= 1) return null;

    const divWrapper = document.createElement('div');
    const nav = document.createElement('nav');
    const nextArrow = document.createElement('li');
    const prevArrow = document.createElement('li');
    const numberList = document.createElement('ul');

    nextArrow.classList.add('next-arrow', 'caret');
    nextArrow.innerHTML = `<a><svg xmlns="http://www.w3.org/2000/svg" width="22" viewBox="0 0 22 22"><defs><clipPath><path fill="#00f" fill-opacity=".514" d="m-7 1024.36h34v34h-34z"/></clipPath><clipPath><path fill="#aade87" fill-opacity=".472" d="m-6 1028.36h32v32h-32z"/></clipPath></defs><path d="m345.44 248.29l-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373" transform="matrix(.03541-.00013.00013.03541 2.98 3.02)" fill="#4d4d4d"/></svg><a>`;
    prevArrow.classList.add('prev-arrow', 'caret', 'hidden');
    prevArrow.innerHTML = `<a><svg xmlns="http://www.w3.org/2000/svg" width="22" style="transform: rotate(180deg);" viewBox="0 0 22 22"><defs><clipPath><path fill="#00f" fill-opacity=".514" d="m-7 1024.36h34v34h-34z"/></clipPath><clipPath><path fill="#aade87" fill-opacity=".472" d="m-6 1028.36h32v32h-32z"/></clipPath></defs><path d="m345.44 248.29l-194.29 194.28c-12.359 12.365-32.397 12.365-44.75 0-12.354-12.354-12.354-32.391 0-44.744l171.91-171.91-171.91-171.9c-12.354-12.359-12.354-32.394 0-44.748 12.354-12.359 32.391-12.359 44.75 0l194.29 194.28c6.177 6.18 9.262 14.271 9.262 22.366 0 8.099-3.091 16.196-9.267 22.373" transform="matrix(.03541-.00013.00013.03541 2.98 3.02)" fill="#4d4d4d"/></svg><a>`;

    for (let i = 0; i < this.pages.total; i++) {
      const pageNumber = document.createElement('li');
      pageNumber.innerText = i + 1;
      pageNumber.classList.add('page-number');

      if (i === 0) pageNumber.classList.add('current');

      numberList.appendChild(pageNumber);
    }

    numberList.prepend(prevArrow);
    numberList.append(nextArrow);

    divWrapper.classList.add('pagination');
    nav.classList.add('pagination--nav');

    // Distinct accessible name per pagination landmark (set in main-search.liquid)
    const paginationLabel = $Q(`#${this.id}-list`)?.dataset.paginationLabel;
    if (paginationLabel) nav.setAttribute('aria-label', paginationLabel);
    nav.appendChild(numberList);
    divWrapper.appendChild(nav);

    this.updateHeaderInfo();

    return divWrapper;
  }

  /**
   * It reads click event on pagination buttons
   * @param {HTMLElement} parent : It is the parent for the buttons
   */
  readClick(parent) {
    const nextArrow = $Q('nav .next-arrow', parent);
    const prevArrow = $Q('nav .prev-arrow', parent);
    const pageNumbers = $Qll('nav .page-number', parent);

    this.clickNextAction(nextArrow);
    this.clickPrevAction(prevArrow);
    this.clickNumberAction(pageNumbers);
  }

  /**
   * It makes the operations in pages object when next is clicked
   * @param {HTMLElement} nextArrow : This is the element for next button
   */
  clickNextAction(nextArrow) {
    nextArrow.addEventListener('click', () => {
      if (this.pages.current === this.pages.total) return;

      this.pages.prev = this.pages.current;
      this.pages.current += 1;

      if (this.pages.next > this.pages.total) {
        this.pages.next = this.pages.current + 1;
      } else {
        this.pages.next = null;
      }

      this.updatePages();
    });
  }

  /**
   * It makes the operations in pages object when prev is clicked
   * @param {HTMLElement} prevArrow : This is the element for prev button
   */
  clickPrevAction(prevArrow) {
    prevArrow.addEventListener('click', () => {
      if (this.pages.current === 1) return;

      this.pages.next = this.pages.current;
      this.pages.current -= 1;

      if (this.pages.prev > 1) {
        this.pages.prev = this.pages.current - 1;
      } else {
        this.pages.prev = null;
      }

      this.updatePages();
    });
  }

  /**
   * It makes the operations in pages object when number buttons are clicked
   * @param {HTMLCollection} pageNumbers : They are the elements for number buttons
   */
  clickNumberAction(pageNumbers) {
    pageNumbers.forEach((page, index) => {
      page.addEventListener('click', () => {
        if (this.pages.current === index + 1) return;

        this.pages.current = index + 1;

        if (this.pages.current === this.pages.total) {
          this.pages = {
            ...this.pages,
            next: null,
            prev: this.pages.current - 1,
          };
        } else if (this.pages.current === 1) {
          this.pages = {
            ...this.pages,
            next: this.pages.current + 1,
            prev: null,
          };
        } else {
          this.pages = {
            ...this.pages,
            next: this.pages.current + 1,
            prev: this.pages.current - 1,
          };
        }

        this.updatePages();
      });
    });
  }

  /**
   * It updates which page have to be shown on DOM
   */
  updatePages() {
    const container = $Q(`.category-container[data-id="${this.id}"]`);
    const pagesElements = $Qll('.page', container);

    pagesElements.forEach((page) => {
      const id = page.dataset.id;
      const currentPage = this.pages.current;

      if (id === currentPage.toString()) {
        page.classList.remove('hidden');
      } else {
        page.classList.add('hidden');
      }
    });

    this.setHeaderInfo();
    this.updateHeaderInfo();
    this.updatePagination();
  }
}

export { Pagination };
